<template>
  <div class="text-lg text-center text-gray-500 border-b border-gray-400">
    <ul class="flex flex-wrap -mb-px">
      <li class="mr-4">
        <a
          @click="togglePage(0)"
          class="inline-block p-4 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-500 cursor-pointer"
          :class="getActivePage(0)"
          >Lekkernijen</a
        >
      </li>
      <li class="mr-4">
        <a
          @click="togglePage(1)"
          class="inline-block p-4 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-500 cursor-pointer"
          :class="getActivePage(1)"
          >Pakketten</a
        >
      </li>
      <li class="mr-4">
        <a
          @click="togglePage(2)"
          class="inline-block p-4 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-600 cursor-pointer"
          :class="getActivePage(2)"
          >Team</a
        >
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Tabs-component',
  props: {
    currentTab: {
      type: Number,
      default: 0,
    },
  },
  emits: ['togglePage'],
  setup(props, { emit }) {
    function togglePage(newValue: number) {
      emit('togglePage', newValue);
    }

    function getActivePage(pageNumber: number) {
      if (pageNumber === props.currentTab) {
        return 'text-pink-600 active border-pink-500 ';
      }
      return '';
    }

    return { togglePage, getActivePage };
  },
});
</script>

<style lang="scss" scoped></style>
